import React, { Component } from 'react'

import { HashRouter, Route, Routes, Navigate } from 'react-router-dom'
import './scss/style.scss'
import './scss/volt.scss'

import { Auth } from 'aws-amplify'
import Amplify from 'aws-amplify'
import awsconfig from './aws-exports'

import { CSpinner } from '@coreui/react'

Amplify.configure(awsconfig)

const loading = (
  <div className="pt-3 text-center">
    <div className="sk-spinner sk-spinner-pulse"></div>
  </div>
)

// Containers
const DefaultLayout = React.lazy(() => import('./layout/DefaultLayout'))

// Pages
const Login = React.lazy(() => import('./views/pages/login/Login'))
const Register = React.lazy(() => import('./views/pages/register/Register'))
const ForgotPassword = React.lazy(() => import('./views/pages/forgotPassword/ForgotPassword'))
const ResetPassword = React.lazy(() => import('./views/pages/resetPassword/ResetPassword'))
const Lock = React.lazy(() => import('./views/pages/lock/Lock'))
const ConfirmEmail = React.lazy(() => import('./views/pages/confirmEmail/ConfirmEmail'))
const RecoverPassword = React.lazy(() => import('./views/pages/forgotPassword/RecoverPassword'))
const Page404 = React.lazy(() => import('./views/pages/page404/Page404'))
const Page500 = React.lazy(() => import('./views/pages/page500/Page500'))

class App extends Component {
  constructor(props) {
    super(props)
    this.onSignIn = this.onSignIn.bind(this)
    // this.fetch_index_info_from_dynamo_table = this.fetch_index_info_from_dynamo_table.bind(this)
    // this.fetch_dashboard_data_from_dynamo_table =
    //   this.fetch_dashboard_data_from_dynamo_table.bind(this)
    this.state = { loggedIn: false, isLoading: true, domainNamesArray: [] }
  }

  async componentDidMount() {
    // await this.fetch_index_info_from_dynamo_table()
    // await this.fetch_dashboard_data_from_dynamo_table()
    await this.signIn()
  }

  // async fetch_index_info_from_dynamo_table() {
  //   try {
  //     const response = await API.graphql({
  //       query: queries.listTenantInfoWebsitesAmplifies,
  //     })

  //     let index_info = response.data.listTenantInfoWebsitesAmplifies

  //     if (index_info === null) index_info = {}

  //     localStorage.setItem('tenantIndexInfo', JSON.stringify(index_info.items))

  //     let domain_names = []
  //     for (let i = 0; i < index_info.length; i++) {
  //       const item = index_info[i]['domainName']
  //       domain_names.push(item)
  //     }

  //     this.setState({ domainNamesArray: ['grhosp.on.ca'] })
  //     console.log('\n*********  website index info', index_info.items)
  //   } catch (error) {
  //     console.log('Error fetching data from db: ', error)
  //   }
  // }

  // async fetch_dashboard_data_from_dynamo_table() {
  //   try {
  //     if (this.state.domainNamesArray.length > 0) {
  //       const number_questions = await API.graphql({
  //         query: queries.tenantMainDashboardAplify,
  //         variables: { domainName: this.state.domainNamesArray[0] },
  //       })

  //       let data = number_questions.data.TenantMainDashboardAplify

  //       if (data === null) data = {}

  //       localStorage.setItem('tenantDahsboardData', JSON.stringify(data))

  //       console.log('\n*********  App main API cal', data)
  //     }
  //   } catch (error) {
  //     console.log('Error fetching data from db: ', error)
  //   }
  // }

  signIn = async () => {
    await Auth.currentAuthenticatedUser()
      .then((data) => {
        this.setState({ loggedIn: true, isLoading: false })
        // console.log(this.state.loggedIn, 'logged in true', data)
      })
      .catch(() => {
        this.setState({ loggedIn: false, isLoading: false })
      })
  }

  onSignIn() {
    this.setState({ loggedIn: true })
  }

  render() {
    if (this.state.isLoading) {
      return <CSpinner color="primary" />
    }
    return (
      <HashRouter>
        <React.Suspense fallback={loading}>
          <Routes>
            <Route path="/login" element={<Login onSignIn={this.onSignIn} />} />
            <Route path="/register" element={<Register />} />
            <Route path="/forgotPassword" element={<ForgotPassword />} />
            <Route path="/resetPassword" element={<ResetPassword />} />
            <Route path="/confirmEmail" element={<ConfirmEmail />} />
            <Route path="/recoverPassword" element={<RecoverPassword />} />
            <Route path="/lock" element={<Lock />} />
            <Route path="/404" element={<Page404 />} />
            <Route path="/500" element={<Page500 />} />
            <Route
              path="*"
              element={this.state.loggedIn ? <DefaultLayout /> : <Navigate to="/login" />}
            />
          </Routes>
        </React.Suspense>
      </HashRouter>
    )
  }
}

export default App
